const frJSON = {};

export default frJSON;
